import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import { AuthorizationVoteSearchPersonCrumbs } from 'front-office/constants/authorization-vote-crumbs';
import ActionsList from 'front-office/components/authorization-vote/actions';

const AuthorizationVoteSearchPersonPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={AuthorizationVoteSearchPersonCrumbs} />
      <PersonSearch
        pathname="/sportello/autorizzazione-voto/stampa"
        addedTitle="- Autorizzazione al voto"
        action={ActionsList}
      />
    </Fragment>
  );
};

AuthorizationVoteSearchPersonPage.displayName = 'Authorization Vote Search Person page component';

export default AuthorizationVoteSearchPersonPage;
